module.exports = __webpack_public_path__ + "static/media/Logo-Yellow.ef73f88b.svg";